// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  Label,
  Alert,
} from "reactstrap";
import { useState, useEffect } from "react";
// core components
import Header from "components/Headers/Header.js";
import { useHistory } from "react-router-dom";
import LivecreateDropzone2 from "views/components/ImageUpload";
import ButtonLoading from "../ButtonLoading";
import { postApiImageUploadService } from "services/apiServices";
import { GAME_UPDATE_API } from "services/CONSTANTS";
import { toast } from "react-toastify";
import { MdModeEditOutline } from "react-icons/md";
import classes from "./GameInfoEdit.module.css";
import { SETTING, UPDATE_SETTING } from "../../../services/CONSTANTS";
import { getApiDataService } from "services/apiServices";
import { set } from "lodash";
import { postApiDataService } from "services/apiServices";

const GameInfoEdit = (props) => {
  const { game, regions, id } = props;
  const [editGameLoading, setEditGameLoading] = useState(false);

  const [name, setName] = useState(null);
  const [unitName, setUnitName] = useState(null);
  const [showZone, setShowZone] = useState(null);
  const [thumbnail, setThumbnail] = useState(null);
  const [thumbnailMyanmar, setThumbnailMyanmar] = useState(null);
  const [thumbnailThailand, setThumbnailThailand] = useState(null);
  const [thumbnailOther, setThumbnailOther] = useState(null);
  const [unitImage, setUnitImage] = useState(null);
  const [directTopup, setDirectTopup] = useState(null);
  const [topupApi, setTopupApi] = useState(null);
  const [status, setStatus] = useState(null);

  const [thumbnailPreview, setThumbnailPreview] = useState(null);
  const [thumbnailMyanmarPreview, setThumbnailMyanmarPreview] = useState(null);
  const [thumbnailThialandPreview, setThumbnailThailandPreview] = useState(null);
  const [thumbnailOtherPreview, setThumbnailOtherPreview] = useState(null);
  const [unitImagePreview, setUnitImagePreview] = useState(null);

  const [imgUpload, setImgUpload] = useState("");
  const [selectedRegions, setSelectedRegions] = useState([]);

  const [isCheckMLAccount, setIsCheckMLAccount] = useState(null);

  useEffect(() => {
    fetchInitData();
  }, []);

  function fetchInitData() {
    console.log("SETTING=", SETTING);
    getApiDataService(SETTING)
      .then((res) => {
        console.log("res.data=", res.data);
        setIsCheckMLAccount(res.data.is_check_ml_account);
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
      });
    return () => {
      console.log("axios cleanup.");
    };
  }

  useEffect(() => {
    let game_region_ids = game?.regions?.map((item) => item.id);
    console.log("regions=",game?.regions);
    console.log("game_region_ids=",game_region_ids);
    setName(game.name);
    setUnitName(game.unit_name);
    setShowZone(game.is_show_zone);
    setThumbnailPreview(game.thumbnail);
    setThumbnailMyanmarPreview(game.thumbnail_myanmar);
    setThumbnailThailandPreview(game.thumbnail_thailand);
    setThumbnailOtherPreview(game.thumbnail_other);
    setUnitImagePreview(game.unit_image);
    setSelectedRegions(game_region_ids);
    setDirectTopup(game.is_direct_topup);
    setTopupApi(game.topup_api);
    setStatus(game.status);
  }, [game]);
  console.log(game);

  const handleEditGameInfo = (e) => {
    e.preventDefault();
    setEditGameLoading(true);
    let fd = new FormData();
    fd.append("name", name);
    fd.append("unit_name", unitName);
    fd.append("is_show_zone", showZone);
    fd.append("is_direct_topup", directTopup);
    fd.append("topup_api", topupApi);
    status && fd.append("status", status);
    thumbnail && fd.append("thumbnail", thumbnail);
    thumbnailMyanmar && fd.append("thumbnail_myanmar", thumbnailMyanmar);
    thumbnailThailand && fd.append("thumbnail_thailand", thumbnailThailand);
    thumbnailOther && fd.append("thumbnail_other", thumbnailOther);
    unitImage && fd.append("unit_image", unitImage);
    selectedRegions.length > 0 &&
      selectedRegions.forEach((item, index) => {
        fd.append(`region_ids[${index}]`, item);
      });

    postApiImageUploadService(GAME_UPDATE_API(game.id), fd)
      .then((res) => {
        console.log("res.data=", res);
        setEditGameLoading(false);
        props.onSubmitComplete();
      })
      .catch((err) => {
        setEditGameLoading(false);
      });
  };

  const handleRegionChange = (id) => {
    if (selectedRegions.includes(id)) {
      setSelectedRegions(selectedRegions.filter((item) => item != id));
    } else {
      setSelectedRegions([...selectedRegions, id]);
    }
  };

  const handleUnitChange = (e) => {
    setUnitName(e.target.value);
  };
  const handleNameChange = (e) => {
    setName(e.target.value);
  };
  const handleTopupApiChange = (e) => {
    setTopupApi(e.target.value);
  };

  const handleShowZoneChange = (e) => {
    console.log("e.target.checked=", e.target.checked);
    setShowZone(e.target.checked);
  };
  const handleIsCheckMLAccount = (e) => {
    console.log("handleIsCheckMLAccount e.target.checked=", e.target.checked);
    setIsCheckMLAccount(e.target.checked);
    postApiDataService(UPDATE_SETTING, {
      is_check_ml_account: e.target.checked,
    })
      .then((res) => {
        console.log("res.data=", res.data);
        toast.success("Updated Success!");
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        toast.error("Update failed!");
      });
  };

  const handleDirectTopupChange = (e) => {
    console.log("e.target.checked=", e.target.checked);
    setDirectTopup(e.target.checked);
  };

  const handleStatusChange = (e) => {
    console.log("e.target.value=", e.target.value);
    setStatus(e.target.value);
  };

  const handleThumbnailChange = (e) => {
    const file = e.target.files[0];
    setThumbnail(file);
    const reader = new FileReader();
    reader.onload = () => {
      setThumbnailPreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleThumbnailMyanmarChange = (e) => {
    const file = e.target.files[0];
    setThumbnailMyanmar(file);
    const reader = new FileReader();
    reader.onload = () => {
      setThumbnailMyanmarPreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleThumbnailThailandChange = (e) => {
    const file = e.target.files[0];
    setThumbnailThailand(file);
    const reader = new FileReader();
    reader.onload = () => {
      setThumbnailThailandPreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleThumbnailOtherChange = (e) => {
    const file = e.target.files[0];
    setThumbnailOther(file);
    const reader = new FileReader();
    reader.onload = () => {
      setThumbnailOtherPreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleUnitImageChange = (e) => {
    const file = e.target.files[0];
    setUnitImage(file);
    const reader = new FileReader();
    reader.onload = () => {
      setUnitImagePreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  console.log("upload image file", imgUpload);

  return (
    <>
      <Container className="mt--7" fluid>
        <Row className="justify-content-center">
          <Col className="order-xl-1 " xl="12">
            <Card className="shadow bg-secondary">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="10">
                    <h3 className="mb-0"> ဂိမ်းအချက်အလက်များပြင်ရန်</h3>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form>
                  <div className="pl-lg-4">
                    <Row className=" align-items-center">
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-username"
                          >
                            Game Name
                          </label>
                          <Input
                            className="form-control-alternative"
                            value={name}
                            onChange={handleNameChange}
                            id="input-username"
                            type="text"
                          />
                        </FormGroup>
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-first-name"
                          >
                            Game Unit
                          </label>
                          <Input
                            onChange={handleUnitChange}
                            className="form-control-alternative"
                            defaultValue={unitName}
                            id="input-first-name"
                            type="text"
                          />
                        </FormGroup>
                        
                        {/* Regions Selection Section */}
                        <FormGroup className="mt-4 p-3 border rounded bg-light">
                          <Label className="form-control-label d-block mb-3 font-weight-bold">
                            Choose Regions
                          </Label>
                          <div className="region-list">
                            {regions.map((region) => {
                              return (
                                <div key={region.id} className="form-check mb-2">
                                  <input
                                    type="checkbox"
                                    id={region.country_name}
                                    checked={selectedRegions?.includes(region.id)}
                                    className="form-check-input"
                                    onChange={() => handleRegionChange(region.id)}
                                  />
                                  <label className="form-check-label" htmlFor={region.country_name}>
                                    {region.country_name}
                                  </label>
                                </div>
                              );
                            })}
                          </div>
                        </FormGroup>

                        {/* Zone ID Section */}
                        <FormGroup className="mt-4 p-3 border rounded bg-light">
                          <Label className="form-control-label d-block mb-3 font-weight-bold">
                            Zone Configuration
                          </Label>
                          <div className="form-check">
                            <Input
                              id="is_show_zone"
                              onClick={handleShowZoneChange}
                              type="checkbox"
                              checked={showZone}
                              className="form-check-input"
                            />
                            <Label check htmlFor="is_show_zone" className="form-check-label">
                              Required Zone ID
                            </Label>
                          </div>
                        </FormGroup>

                        {/* Status Section */}
                        <FormGroup className="mt-4 p-3 border rounded bg-light">
                          <Label className="form-control-label d-block mb-3 font-weight-bold">
                            Status
                          </Label>
                          <div className="form-check mb-2">
                            <Input
                              id="status_active"
                              onClick={handleStatusChange}
                              type="radio"
                              value={"active"}
                              name="status"
                              checked={status === "active"}
                              className="form-check-input"
                            />
                            <Label check htmlFor="status_active" className="form-check-label">
                              Active — shown on the customer website
                            </Label>
                          </div>
                          <div className="form-check">
                            <Input
                              id="status_disable"
                              onClick={handleStatusChange}
                              type="radio"
                              value={"disable"}
                              name="status"
                              checked={status === "disable"}
                              className="form-check-input"
                            />
                            <Label check htmlFor="status_disable" className="form-check-label">
                              Disable — hidden from the customer website
                            </Label>
                          </div>
                          <small className="form-text text-muted mt-2">
                            Newly imported games start as Disable. Set the prices
                            first, then switch to Active to make the game sellable.
                          </small>
                        </FormGroup>

                        {(name?.includes("Mobile Le") || name?.includes("Magic")) && (
                          <FormGroup className="mt-4 p-3 border rounded bg-light">
                            <Label className="form-control-label d-block mb-3 font-weight-bold">
                              Topup Configuration
                            </Label>
                            
                            {/* Direct Topup Checkbox */}
                            <div className="form-check mb-3">
                              <Input
                                id="direct_topup"
                                onClick={handleDirectTopupChange}
                                type="checkbox"
                                checked={directTopup}
                                className="form-check-input"
                              />
                              <Label check htmlFor="direct_topup" className="form-check-label">
                                Direct Topup ({topupApi})
                              </Label>
                            </div>

                            {/* API Selection - Only show when Direct Topup is enabled and Mobile Le */}
                            {(directTopup && name?.includes("Mobile Le")) && (
                              <div className="mt-3 pl-3 border-left">
                                <Label className="form-control-label d-block mb-2 text-muted">
                                  Select Topup API:
                                </Label>
                                <div className="form-check mb-2">
                                  <Input
                                    id="PrepaidCard"
                                    onClick={handleTopupApiChange}
                                    type="radio"
                                    value={"prepaid"}
                                    name="topupApi"
                                    checked={topupApi === "prepaid"}
                                    className="form-check-input"
                                  />
                                  <Label check htmlFor="PrepaidCard" className="form-check-label">
                                    PrepaidCard API
                                  </Label>
                                </div>
                                <div className="form-check mb-2">
                                  <Input
                                    id="SmileOne"
                                    onClick={handleTopupApiChange}
                                    type="radio"
                                    value={"smileone"}
                                    name="topupApi"
                                    checked={topupApi === "smileone"}
                                    className="form-check-input"
                                  />
                                  <Label check htmlFor="SmileOne" className="form-check-label">
                                    SmileOne API
                                  </Label>
                                </div>
                                <div className="form-check mb-2">
                                  <Input
                                    id="Unipin"
                                    onClick={handleTopupApiChange}
                                    type="radio"
                                    value={"unipin-scraping"}
                                    name="topupApi"
                                    checked={topupApi === "unipin-scraping"}
                                    disabled
                                    className="form-check-input"
                                  />
                                  <Label check htmlFor="Unipin" className="form-check-label text-muted">
                                    Unipin Scraping (Disabled)
                                  </Label>
                                </div>
                              </div>
                            )}

                            {/* ML Account Check */}
                            <div className="form-check mt-3">
                              <Input
                                id="is_check_ml_account"
                                onClick={handleIsCheckMLAccount}
                                type="checkbox"
                                checked={isCheckMLAccount}
                                className="form-check-input"
                              />
                              <Label check htmlFor="is_check_ml_account" className="form-check-label">
                                Check ML Account
                              </Label>
                            </div>
                          </FormGroup>
                        )}
                      </Col>
                      <Col lg="3" className="justify-content-center">
                        <input
                          className={classes.imgPreview}
                          type="file"
                          name="file"
                          id="thumbnail"
                          accept="image/*"
                          onChange={handleThumbnailChange}
                        />
                        <label
                          for="thumbnail"
                          className={classes.imgPreviewCard}
                        >
                          <img src={thumbnailPreview} alt="" />
                          <div className={classes["edit-pen"]}>
                            <MdModeEditOutline />
                          </div>
                        </label>
                      </Col>
                      <Col lg="3">
                        <input
                          className={classes.imgPreview}
                          type="file"
                          name="file"
                          id="unitImage"
                          accept="image/*"
                          onChange={handleUnitImageChange}
                        />
                        <label
                          for="unitImage"
                          className={classes.logoPreviewCard}
                        >
                          <img src={unitImagePreview} alt="" />
                          <div className={classes["edit-pen"]}>
                            <MdModeEditOutline />
                          </div>
                        </label>
                      </Col>
                    </Row>
                    <Row className=" align-items-center mt-5">
                      <Col lg="3" className="justify-content-center">
                      <Label className="pl-2">Myanmar</Label>
                        <input
                          className={classes.imgPreview}
                          type="file"
                          name="file"
                          id="thumbnail_myanmar"
                          accept="image/*"
                          onChange={handleThumbnailMyanmarChange}
                        />
                        <label
                          for="thumbnail_myanmar"
                          className={classes.imgPreviewCard}
                        >
                          <img src={thumbnailMyanmarPreview} alt="" />
                          <div className={classes["edit-pen"]}>
                            <MdModeEditOutline />
                          </div>
                        </label>                        
                      </Col>
                      <Col lg="3" className="justify-content-center">
                      <Label className="pl-2">Thai</Label>
                        <input
                          className={classes.imgPreview}
                          type="file"
                          name="file"
                          id="thumbnail_thailand"
                          accept="image/*"
                          onChange={handleThumbnailThailandChange}
                        />
                        <label
                          for="thumbnail_thailand"
                          className={classes.imgPreviewCard}
                        >
                          <img src={thumbnailThialandPreview} alt="" />
                          <div className={classes["edit-pen"]}>
                            <MdModeEditOutline />
                          </div>
                        </label>                        
                      </Col>                      
                      <Col lg="3" className="justify-content-center">
                      <Label className="pl-2">Global</Label>
                        <input
                          className={classes.imgPreview}
                          type="file"
                          name="file"
                          id="thumbnail_other"
                          accept="image/*"
                          onChange={handleThumbnailOtherChange}
                        />
                        <label
                          for="thumbnail_other"
                          className={classes.imgPreviewCard}
                        >
                          <img src={thumbnailOtherPreview} alt="" />
                          <div className={classes["edit-pen"]}>
                            <MdModeEditOutline />
                          </div>
                        </label>
                      </Col>
                    </Row>
                  </div>

                  {/* <hr className="my-4" /> */}
                </Form>
              </CardBody>
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  padding: "10px",
                }}
              >
                <div
                  style={{
                    width: "fit-content",
                    minWidth: "100px",
                    marginRight: "20px",
                  }}
                >
                  <ButtonLoading
                    className="m-1 "
                    loading={editGameLoading}
                    onClick={handleEditGameInfo}
                    disabled={editGameLoading}
                    color="info"
                    block={!editGameLoading}
                    outline={false}
                  >
                    Save
                  </ButtonLoading>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default GameInfoEdit;
